import feather from 'feather-icons';

/**
 * Get the SVG markup for a Feather icon
 * @param {string} name - Icon name
 * @param {number} [size=18] - Icon size in pixels
 * @param {number} [strokeWidth=2] - Stroke width
 * @returns {string} SVG markup
 */
export function getIconSvg(name, size = 18, strokeWidth = 2) {
  if (!name) return '';
  
  try {
    return feather.icons[name]?.toSvg({
      width: size,
      height: size,
      'stroke-width': strokeWidth
    }) || '';
  } catch (error) {
    console.error(`Error loading icon ${name}:`, error);
    return '';
  }
} 